
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectWS","sendEvent","closeWS","getTradeBlotterAfterALotTime","test"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "7d28840c7f6d821a55a9.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "7d28840c7f6d821a55a9.worker.js");
					addMethods(w, methods)
					
					return w
				}
			